import React from 'react';
import LocationTag from '../../../controls/LocationTag';
import Notes from '../../../controls/Notes';

export const getNotesSection = (props) => {
  const {
    isDisabled,
    locationTagValue, setLocationTagValue,
    notesValue, setNotesValue,
  } = props;

  return [
    // notes section starts ...
    { id: "LocationTag", component: <LocationTag
      disabled={isDisabled}
      value={locationTagValue} // ✅ScreenDetails Pass current state value
      onChange={(newValue) =>
      { setLocationTagValue(newValue); }
    }/>, position: [1, 1], status: "active", expandableSectionId: "Notes" },

    { id: "Notes",  component: <Notes
      disabled={isDisabled}
      value={notesValue} // ✅ScreenDetails Pass current state value
      onChange={(newValue) =>
      { setNotesValue(newValue); }
    }/>, position: [2, "1 / span 3"], status: "active", expandableSectionId: "Notes" },
    // notes ends ...
  ];
};
